import { useContext } from "react";
import { API_ENDPOINT } from "../constants/api-endpoints";
import SettingsContext from "../contexts/SettingsProvider";
import { useApiService } from "./useApiService";
import { useHandleErrorService } from "./useHandleErrorService";
import { ISettingsResponse } from "../interfaces/common-interfaces";

export const useSettingsService = (displayId: string) => {

    const { fetchPublicRequest } = useApiService();
    const { handleError } = useHandleErrorService();
    const { setSettings } = useContext(SettingsContext)

    const fetchSettings = async () => {
        try {
            const response = await fetchPublicRequest(
                API_ENDPOINT.DISPLAY_SETTINGS(displayId),
            );
            const settings = response.data.object as ISettingsResponse;

            setSettings({
                division: settings.division.id.toString(),
                ghat: settings.ghat.id.toString(),
                ghatName: settings.ghat.ghatName,
                dockNo: settings.dockNo || '',
                displayName: settings.displayName,
                header1FontSize: settings.header1FontSize,
                header2FontSize: settings.header2FontSize,
                tableBodyFontSize: settings.tableBodyFontSize,
                splitIndex: settings.splitIndex,
                slideInDuration: settings.slideInDuration,
                apiCallFrequency: settings.apiCallFrequency,
                languageToggleInterval: settings.languageToggleInterval,
                displayTextList: settings.displayTextList.map(text => text.displayText)
            })
        } catch (error) {
            handleError(error);
        }
    }

    return {
        fetchSettings
    }
}